import { z } from 'zod';
import {
  addressResourceSchema,
  contactResourceSchema,
  coordinatesResourceSchema,
  urlResourceSchema,
  visitTypeResourceSchema,
} from './common.contracts';

export const officeHoursResourceSchema = z.object({
  formatted: z.string(),
});
export type OfficeHoursResource = z.infer<typeof officeHoursResourceSchema>;

export const LocationBaseResource = z.object({
  id: z.string(),
  urls: z.array(urlResourceSchema),
  address: addressResourceSchema,
  contacts: z.array(contactResourceSchema),
  coordinates: coordinatesResourceSchema.nullable(),
  capabilities: z.array(z.string()),
  officeHours: officeHoursResourceSchema.nullable(),
  isPrimaryLocation: z.boolean(),
  availability: z.number().default(0),
  visitTypes: z.array(visitTypeResourceSchema),
});
export type LocationBaseResource = z.infer<typeof LocationBaseResource>;

export const locationResourceSchema = LocationBaseResource.extend({
  name: z.string(),
  ehrExternalId: z.string().nullable(),
});
export type LocationResource = z.infer<typeof locationResourceSchema>;

export interface LocationData {
  label: string;
  value: string;
  lat: number;
  lng: number;
}

export const currentLocationKey = 'Current location';
